module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_5.ad13f2b1.png";